module.exports = __webpack_public_path__ + "img/star-room.884786d0.svg";